module.exports = __webpack_public_path__ + "img/symbol_17.150c6d50.png";